import {settleExistingSection} from '../../core/actionHighlighter';
import {dispatchAcknowledgedEvent} from '../../core/resourceEvents';
import {FLOOR_PLAN_FILTER_EVENT, FLOOR_PLAN_FOCUS_EVENT} from './events';

// The heading Canvas renders on the accordion, which is also the name it
// carries in `data-agent-section`. Marked rather than matched on text: the
// Add control renders inside the summary once it is open, so the words read
// "Floor PlansAdd" and match nothing - the same trap the Guest Access Plans
// accordion had.
const HEADING = 'Floor Plans';

/**
 * Open the Floor Plans accordion on the Site dashboard.
 *
 * Nothing navigates here: the agent reaches a Site's dashboard through the
 * Site resource, and this opens the accordion once that page is showing.
 *
 * @return {Promise<object>} what the page reports it opened
 */
export async function openFloorPlanSection() {
	try {
		const seen = await settleExistingSection(HEADING);
		return {...(seen || {}), section_id: 'site.floor_plans'};
	} catch (_) {
		throw new Error('site_floor_plans_unavailable');
	}
}

/**
 * Narrow the Floor Plans table to a search term.
 * @param {object} command filter command
 * @return {Promise<object>} acknowledgement
 */
export function applyFloorPlanFilter(command) {
	return dispatchAcknowledgedEvent(FLOOR_PLAN_FILTER_EVENT, {
		query: String(command.params?.query || '').trim(),
		resource: 'floor_plan',
	});
}

/**
 * Bring one floor plan's row into view.
 * @param {object} command focus command
 * @return {Promise<object>} acknowledgement
 */
export function focusFloorPlan(command) {
	return dispatchAcknowledgedEvent(FLOOR_PLAN_FOCUS_EVENT, {
		entityId: String(command.params?.entity_id || ''),
		resource: 'floor_plan',
	});
}
